import { Checkbox } from "@progress/kendo-react-inputs";

export const IsEditableProperty = {
  propertyName: "IsEditable",
  propertyDisplay: "Is Editable in Grid?",
  propertyType: "boolean",
  propertyCategory: "Validation",
  renderer: function ({ handlePropertyChange, currentPropertyValues }) {
    return (
      <Checkbox
        name={this.propertyName}
        title={currentPropertyValues?.IsDetail ? "Cannot be selected while Is Detail is True" : ""}
        disabled={currentPropertyValues?.IsDetail || false}
        onChange={(e) => {
          handlePropertyChange({ propName: this.propertyName, propValue: e.target.value });
          handlePropertyChange({ propName: "IsDetail", propValue: false });
        }}
        defaultValue={currentPropertyValues?.[this.propertyName] || false}
      />
    );
  },
};
